import { useIntl } from "react-intl"
import ExternalLink from "../../ui/ExternalLink"

interface TranslatedExternalLinkProps {
  linkId: string
  text: string | string[]
}

export function TranslatedExternalLink({
  linkId,
  text,
}: TranslatedExternalLinkProps) {
  const intl = useIntl()

  return (
    <ExternalLink href={intl.formatMessage({id: linkId})}>{text}</ExternalLink>
  )
}
